import { z } from "zod";

const previewSchema = z.object({
  fingerprint: z.string().regex(/^[a-f0-9]{64}$/),
  canOverwrite: z.boolean(),
  conflictList: z
    .array(
      z.object({
        id: z.string(),
        inventoryId: z.string(),
        inventoryName: z.string(),
        year: z.number().int(),
        sectorId: z.string(),
        subsectorId: z.string(),
        energySourceId: z.string(),
        previousAmount: z.number().finite(),
        projectedAmount: z.number().finite(),
        notationKey: z.string().nullable(),
      }),
    )
    .min(1),
});
export type MunicipalPropertyGhgConflictPreview = z.infer<typeof previewSchema>;

const errorSchema = z.object({
  response: z.object({
    errors: z.array(
      z.object({
        extensions: z.object({ code: z.string().optional(), conflictPreview: z.unknown().optional() }).optional(),
      }),
    ),
  }),
});

export function readMunicipalPropertyGhgConflict(error: unknown): MunicipalPropertyGhgConflictPreview | null {
  const parsed = errorSchema.safeParse(error);
  if (!parsed.success) return null;
  const extension = parsed.data.response.errors.find(
    (entry) => entry.extensions?.code === "MUNICIPAL_PROPERTY_GHG_MANUAL_CONFLICT",
  )?.extensions;
  const preview = previewSchema.safeParse(extension?.conflictPreview);
  return preview.success ? preview.data : null;
}
